import { useEffect } from "react";

/**
 * Updates the document <title> and meta tags for a specific page/post.
 * Falls back to the school name when fields are not set.
 */
export default function SeoHead({ title, description, ogImage, schoolName }) {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${schoolName || ""}` : schoolName || "School Website";
    document.title = pageTitle;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", description || "");

    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute("content", pageTitle);

    if (ogImage) {
      let ogImg = document.querySelector('meta[property="og:image"]');
      if (!ogImg) {
        ogImg = document.createElement("meta");
        ogImg.setAttribute("property", "og:image");
        document.head.appendChild(ogImg);
      }
      ogImg.setAttribute("content", ogImage);
    }

    return () => {
      document.title = schoolName || "School App";
    };
  }, [title, description, ogImage, schoolName]);

  return null;
}
